export var ResponseType;
(function (ResponseType) {
    ResponseType["Json"] = "json";
    ResponseType["Response"] = "response";
    ResponseType["Text"] = "text";
})(ResponseType || (ResponseType = {}));
